/* eslint-disable array-callback-return */
import React, { useState, useEffect, useCallback } from "react";
import Cookies from "universal-cookie";
import { MessageBar, TeachingBubble, IIconProps, MessageBarType } from "@fluentui/react";
import { Switch, Link, Route } from "react-router-dom";
import Toggle from "./Toggle";
import PersonStatus from "./PersonStatus";
import PortfolioMenu from "../screen/Portfolios/PortfolioMenu";
import SavingsPlansMenu from "./SavingsPlans/SavingsPlansMenu";
import SearchMenu from "../components/Instruments/Menu";
import IframeSearchMenu from "../components/Instruments/IframeMenu";
import ElementsMenu from "../components/Elements/ElementsMenu";
import "./Header.sass";
import { MainSearch } from "./Buscadores/main/MainSearch";
import Auth from "../Auth/Auth";
import ProfileMenu from "../screen/Profile/ProfileMenu";
import { connect, useSelector, RootStateOrAny, useDispatch } from "react-redux";
import { ReactComponent as SpacerIcon } from "../images/spacer.svg";
import * as Element from "./HeaderStyles";
import StatusService, { StatusBarModel } from "../services/StatusBarService";
import { sanitizeStatusBarHtml } from "../utils/sanitizeStatusBarHtml";
import { USER_ACTIVE_PLAN, SAVINGS_PLAN_ELEMENTS_STATUS } from "../store/auth/Constants";
import { SavingsPlanElementsStatus } from "../services/ElementsService";
import ButtonLogo from "./ButtonLogo";
import CartButton from "./CartButton";

function mapStateToProps(state: any)
{
    return {
        headerVisible: state.ui.headerVisible
    };
}

const Header = (props: any) =>
{
    const user: any = Auth.getUserProfile();
    const activePlan: any = Auth.getActivePlan();
    const savingsPlanElementsStatus = useSelector((state: RootStateOrAny) => state.auth.savingsPlanElementsStatus) as SavingsPlanElementsStatus;
    const activeSavingsPlanHasOutdatedcontract = useSelector((state: RootStateOrAny) => state.auth.userActivePlan?.outdatedContract);
    // Cada incremento vuelve a pedir los avisos al servidor: lo disparan la firma del KYC (que retira el aviso
    // en BD) y la comprobación de caducidad del login (que lo crea). Sin esto la barra solo se cargaba una vez.
    const statusBarVersion = useSelector((state: RootStateOrAny) => state.ui.statusBarVersion);
    const dispatch = useDispatch();
    const cookies = new Cookies();
    const theme = props.theme;
    //let history = useHistory();
    const warningIcon: IIconProps = { iconName: "Warning12" };
    const [bubbleVisible, setBubbleVisible] = useState<boolean>(Auth.bubbleVisible());
    const isActiveManagementPlan = Auth.isActiveManagementPlan();
    const [statusBarElements, setStatusBarElements] = useState<StatusBarModel[]>();

    const checkActiveSavingsPlan = useCallback(async () =>
    {
        await dispatch(
        {
            type: USER_ACTIVE_PLAN,
            payload: Auth.getActivePlan(),
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() =>
    {
        if(!activePlan?.sync)
        {
            checkActiveSavingsPlan();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const checkSavingsPlanElementsStatus = useCallback(async () =>
    {
        await dispatch(
        {
            type: SAVINGS_PLAN_ELEMENTS_STATUS,
            payload: Auth.getSavingsPlanElementsStatus(),
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() =>
    {
        if(!savingsPlanElementsStatus.sync)
        {
            checkSavingsPlanElementsStatus();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() =>
    {
        if(user.id !== undefined)
        {
            StatusService.GetAllStatusBarEnabled(user.id).then((response: StatusBarModel[]) =>
            {
                var cookie = cookies.get("statusBarNotifications") ?? [];

                // El servidor es la fuente de verdad. Antes se mezclaba [...response, ...cookie] y el Map se
                // quedaba con la ÚLTIMA escritura, así que ganaba la cookie y un aviso que solo estaba en ella
                // sobrevivía para siempre: retirarlo en BD no lo quitaba de la pantalla. Ahora se conserva de la
                // cookie solo lo que el servidor sigue devolviendo, y la respuesta va al final para ganar el
                // dedupe. No rompe el descarte manual: onDeleteNotification ya lo persiste en el servidor
                // (setReadNotification / setReadStatusBarNotification), así que un aviso descartado no vuelve en
                // la respuesta y no necesita la cookie para no reaparecer.
                const keyOf = (message: StatusBarModel) => `${message.id}-${message.isGeneralNotification ? "1" : "0"}`;
                const serverKeys = new Set<string>(response.map(keyOf));
                const cookieStillValid = (cookie as StatusBarModel[]).filter((message: StatusBarModel) => serverKeys.has(keyOf(message)));

                let mixItems: StatusBarModel[] = Array.from([...cookieStillValid, ...response]);
                let uniqItems = mixItems.reduce((result, message) =>
                {
                    result.set(keyOf(message), message);
                    return result;
                }, new Map<string, StatusBarModel>());
                let sortedItems = Array.from(uniqItems.values()).sort((a: StatusBarModel, b: StatusBarModel) => b.severityOrder - a.severityOrder);
                setStatusBarElements(sortedItems);
                cookies.set("statusBarNotifications", sortedItems, { path: "/" });
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user.id, statusBarVersion]);

    const onDeleteNotification = (item: StatusBarModel) =>
    {
        const currentNotifications = statusBarElements && statusBarElements.length > 0
                ? statusBarElements
                : cookies.get("statusBarNotifications") ?? [];

        const updatedNotifications = currentNotifications.filter((notification: StatusBarModel) =>
        {
            return notification.id !== item.id || notification.isGeneralNotification !== item.isGeneralNotification;
        });

        setStatusBarElements(updatedNotifications);
        cookies.set("statusBarNotifications", updatedNotifications, { path: "/" });

        if(item.isGeneralNotification)
        {
            StatusService.setReadStatusBarNotification(item.id);
        }
        else
        {
            StatusService.setReadNotification(item.id);
        }
    };

    if(!props.headerVisible)
    {
        return(
            <React.Fragment>
                <Element.HeaderDiv id="header">
                    <Switch>
                        <Route path="/iframe/search" component={IframeSearchMenu} />
                    </Switch>
                </Element.HeaderDiv>
            </React.Fragment>
        );
    }

    const handleMenuButtonClick = (event: any) =>
    {
        event.preventDefault();
        props.menuRef.current.showMenu();
    };

    const handleStatusChange = () =>
    {
        setBubbleVisible(false);
    };

    return(
        <Element.HeaderMain id="header">
            <Element.RowHeader className="ms-Grid-row">
                <Element.ColNineDots className="ms-Grid-col">
                    <Element.ButtonDots title="Mostrar menú" id="show-menu" onClick={handleMenuButtonClick}>
                        <i className="ironia-icon functions" />
                    </Element.ButtonDots>
                </Element.ColNineDots>
                <Element.ColSeparator className="ms-Grid-col">
                    <SpacerIcon className="spacer" />
                </Element.ColSeparator>
                <Element.ColImageLogo className="ms-Grid-col">
                    <ButtonLogo />
                </Element.ColImageLogo>

                {window.innerWidth >= 1024 && (
                    <Element.ColSearch className="ms-Grid-col">
                        <MainSearch theme={theme} />
                    </Element.ColSearch>
                )}

                {((window.innerWidth >= 480 && window.innerWidth <= 639) || window.innerWidth >= 801) && (
                    <>
                        <Element.ColToggle className="ms-Grid-col">
                            <Toggle toggleTheme={props.toggleTheme} identificator="toggle-large" className="A" />
                            {bubbleVisible && window.innerWidth >= 1025 && (
                                <TeachingBubble
                                    target="#toggle-large"
                                    hasCloseButton={true}
                                    onDismiss={handleStatusChange}
                                    headline="Esta es la primera vez que accedes a IronIA"
                                >
                                    Puedes cambiar el tema aquí si lo deseas
                                </TeachingBubble>
                            )}
                        </Element.ColToggle>
                        <Element.ColSeparator2 className="ms-Grid-col">
                            <SpacerIcon className="spacer" />
                        </Element.ColSeparator2>
                    </>
                )}

                {window.innerWidth > 320 && (
                    <Element.ColNotifications className="ms-Grid-col">
                        <Element.ButtonNotifications title="Notificaciones">
                            <i className="ironia-icon notifications" />
                        </Element.ButtonNotifications>
                    </Element.ColNotifications>
                )}

                {window.innerWidth >= 640 && (
                    <Element.ColPersonStatus className="ms-Grid-col">
                        <PersonStatus user={user} />
                    </Element.ColPersonStatus>
                )}

                <Element.ColCartButton className="ms-Grid-col">
                    {isActiveManagementPlan === false && <CartButton />}
                </Element.ColCartButton>
            </Element.RowHeader>
            <Switch>
                <Route path={
                    [
                        "/portfolio",
                        "/portfolio/operations",
                        "/portfolio/file",
                        "/portfolio/orders",
                        "/portfolio/fiscalReport",
                    ]}
                    component={PortfolioMenu}
                />
                <Route path="/savingsPlans" component={SavingsPlansMenu} />
                <Route path="/search" component={SearchMenu} />
                <Route path="/profile" component={ProfileMenu} />
                <Route path={["/elements", "/elements/ranking", "/ElementsIA"]}>
                    <ElementsMenu savingsPlanElementsStatus={savingsPlanElementsStatus} />
                </Route>
            </Switch>
            <Element.RowStatusBar>
                {activeSavingsPlanHasOutdatedcontract &&
                (
                    <MessageBar messageBarType={MessageBarType.blocked} isMultiline={false} dismissButtonAriaLabel="Close" styles={{root:{cursor: "default"}}}>
                        La versión del contrato se ha actualizado. Debes
                        <Link to={`/contract/${activePlan.id}`} style={{cursor: "pointer"}}>
                            firmar la nueva versión
                        </Link>{" "}
                        para poder seguir operando.
                    </MessageBar>
                )}

                {savingsPlanElementsStatus.isSubscribed && savingsPlanElementsStatus.isOutdatedContract &&
                (
                    <MessageBar messageBarType={MessageBarType.blocked} isMultiline={false} dismissButtonAriaLabel="Close" styles={{root:{cursor: "default"}}}>
                        El contrato de Elements se ha actualizado a la versión{" "}
                        {savingsPlanElementsStatus.lastContractVersion}. Debes
                        <Link to={`/Elements/Signature`} style={{cursor: "pointer"}}>firmar la nueva versión</Link>.
                    </MessageBar>
                )}

                {statusBarElements !== undefined && statusBarElements.length > 0 && statusBarElements.map((element, index) =>
                    {
                        if(element.canDelete === true)
                        {
                            return(
                                <React.Fragment key={index}>
                                    <MessageBar
                                        messageBarType={MessageBarType[element.type.toLocaleLowerCase() as keyof typeof MessageBarType]}
                                        isMultiline={false}
                                        dismissButtonAriaLabel="Close"
                                        messageBarIconProps={element.type === "Warning" ? warningIcon : undefined}
                                        onDismiss={() => onDeleteNotification(element)}
                                    >
                                        <Element.StatusBarText dangerouslySetInnerHTML={{ __html: sanitizeStatusBarHtml(element.text) }} />
                                    </MessageBar>
                                </React.Fragment>
                            );
                        }
                        else
                        {
                            return(
                                <React.Fragment key={index}>
                                    <MessageBar
                                        messageBarType={MessageBarType[element.type.toLocaleLowerCase() as keyof typeof MessageBarType]}
                                        isMultiline={false}
                                    >
                                        <Element.StatusBarText dangerouslySetInnerHTML={{ __html: sanitizeStatusBarHtml(element.text) }} />
                                    </MessageBar>
                                </React.Fragment>
                            );
                        }
                    })}
            </Element.RowStatusBar>
        </Element.HeaderMain>
    );
};

export default connect(mapStateToProps)(Header);